import { Box, TableCell, TableRow } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import MediumTypography from '../../components/formlib/MediumTypography';
import ActionToolTip from '../../components/formlib/ActionToolTip';
import { ReactComponent as EditIcon } from '../../assets/images/highlight.svg';
import { ReactComponent as DeleteIcon } from '../../assets/images/DeleteIcon.svg';
import { ReactComponent as MessageIcon } from '../../assets/images/messageIcon.svg';
import ActivityNoteModal from '../../components/formlib/modal/ActivityNoteModal';
import moment from 'moment';
import { GetTimeOffListType } from './MyTimeOff';
import { checkPermissionForFeature } from '../../utils/checkPermission';
import TooltipTableCell from '../../components/formlib/TooltipTableCell';

interface MyTimeOff {
  data: GetTimeOffListType;
  onEdit: (data: GetTimeOffListType) => void;
  onDeleteMyTimeOff: (id: string) => void;
}
const MyTimeOffTableRow: FC<MyTimeOff> = ({
  data,
  onEdit,
  onDeleteMyTimeOff,
}) => {
  
  const isApproved =
    data.status === 'Approved' || data.status === 'Accepted';
  let statusTextColor = '#EB4C60';

  if (data.status === 'Approved' || data.status === 'Accepted') {
    statusTextColor = '#37D183';
  } else if (data.status === 'Pending') {
    statusTextColor = '#F9B803';
  }

  const getDates = () => {
    if (data.durationType === 'days') {
      const startDate = moment(data.effectiveStartDate, 'YYYY-MM-DD');
      const endDate = moment(data.effectiveEndDate, 'YYYY-MM-DD');
      return `${startDate.format('MMM DD, YYYY')} to ${endDate.format(
        'MMM DD, YYYY',
      )} `;
    } else {
      const startDate = moment(data.effectiveStartDate, 'YYYY-MM-DD');
      return `${startDate.format('MMM DD, YYYY')}`;
    }
  };

  const [openNoteModel, setOpenNoteModel] = useState(false);
  const handleOpenNoteModal = () => {
    if (data.reason) {
      setOpenNoteModel(true);
    }
  };

  const handleCloseNoteModal = () => {
    setOpenNoteModel(false);
  };
  const handleEdit = () => {
    onEdit(data);
  };

  useEffect(() => {
    getDates();
  }, []);
  return (
    <>
      {openNoteModel && data.reason && (
        <ActivityNoteModal
          maxLength={2000}
          open={openNoteModel}
          note={data.reason ?? data.reason}
          handleClose={handleCloseNoteModal}
          updateNote={() => {}}
          hideUpdateButton={true}
        />
      )}
      <TableRow>
        <TableCell>
          <MediumTypography
            label={moment(data.appliedDate, 'YYYY-MM-DDTHH:mm')
              .utc(true)
              .local()
              .format('MM/DD/YYYY')}
          />
        </TableCell>

        <TooltipTableCell
          visible={data.leaveName.length > 15}
          value={data.leaveName}
          textSxProps={{ maxWidth: '120px' }}
        />
        {data.durationType === 'days' && (
          <TableCell>
            <Box
              sx={{
                display: 'flex',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                alignItems: 'center',
              }}
            >
              <MediumTypography
                label={getDates()}
                sxProps={{ whiteSpace: { xs: 'normal', sm: 'nowrap' } }}
              />
              <MediumTypography
                textColor="#00C6B8"
                sxProps={{
                  marginLeft: '2px',
                  whiteSpace: { xs: 'normal', sm: 'nowrap' },
                }}
                label={`(${data.totalDays} day(s))`}
              />
            </Box>
          </TableCell>
        )}
        {data.durationType === 'hours' && (
          <TableCell>
            <Box display={'flex'}>
              <MediumTypography label={getDates()} />
              <MediumTypography
                textColor="#00C6B8"
                sxProps={{ marginLeft: '2px' }}
                label={`(${data.noOfHrs} Hour(s))`}
              />
            </Box>
          </TableCell>
        )}
        <TableCell>
          <MediumTypography
            label={data.status}
            textColor={
                statusTextColor

            }
          />
        </TableCell>
        <TableCell>
          <Box
            sx={{
              cursor: 'pointer',
              opacity: data.reason ? 1 : 0.5,
              marginTop: '8px',
            }}
          >
            <ActionToolTip labelId="myTimeOffReason" defaultLabel="Reason">
              <MessageIcon
                stroke={'#97A6A5'}
                onClick={() => handleOpenNoteModal()}
              />
            </ActionToolTip>
          </Box>
        </TableCell>
        {checkPermissionForFeature('backend.time_off', 'editPermission') ||
        checkPermissionForFeature('backend.time_off', 'deletePermission') ? (
          <TableCell>
            <Box display={'flex'} sx={{ marginTop: '8px' }}>
              {checkPermissionForFeature(
                'backend.time_off',
                'editPermission',
              ) && (
                <Box
                  sx={{
                    cursor: 'pointer',
                                        opacity: isApproved ? 0.5 : 1,
                    pointerEvents: isApproved ? 'none' : 'auto',
                    marginRight: '16px',
                  }}
                >
                  <ActionToolTip labelId="MyTimeOffEdit" defaultLabel="Edit">
                    <EditIcon onClick={handleEdit} />
                  </ActionToolTip>
                </Box>
              )}
              {checkPermissionForFeature(
                'backend.time_off',
                'deletePermission',
              ) && (
                <Box
                  sx={{
                    cursor: 'pointer',
                                     }}
                >
                  <ActionToolTip
                    labelId="MyTimeOffDelete"
                    defaultLabel="Delete"
                  >
                    <DeleteIcon onClick={() => onDeleteMyTimeOff(data.id)} />
                  </ActionToolTip>
                </Box>
              )}
            </Box>
          </TableCell>
        ) : null}
      </TableRow>
    </>
  );
};
export default MyTimeOffTableRow;
